// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TCreateAssistantRuleRequestPayload,
  TCreateAssistantRuleResponsePayload,
  TDeleteAssistantRuleRequestPayload,
  TDeleteAssistantRuleResponsePayload,
  TGetAssistantRulesRequestPayload,
  TGetAssistantRulesResponsePayload,
  TGetAssistantSettingsRequestPayload,
  TGetAssistantSettingsResponsePayload,
  TSetGeneralRulesRequestPayload,
  TSetGeneralRulesResponsePayload,
  TUpdateAssistantRuleRequestPayload,
  TUpdateAssistantRuleResponsePayload,
  TUpdateAssistantSettingsRequestPayload,
  TUpdateAssistantSettingsResponsePayload,
} from './assistant-settings.types.ts';

export const createAssistantSettingsApi = (transport: TApiTransport) => ({
  /** Creates an assistant rule */
  createAssistantRule: (
    payload: TCreateAssistantRuleRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCreateAssistantRuleRequestPayload,
      TCreateAssistantRuleResponsePayload
    >('/create_assistant_rule', payload, options),

  /** Deletes an assistant rule */
  deleteAssistantRule: (
    payload: TDeleteAssistantRuleRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteAssistantRuleRequestPayload,
      TDeleteAssistantRuleResponsePayload
    >('/delete_assistant_rule', payload, options),

  /** Lists assistant rules */
  getAssistantRules: (
    payload: TGetAssistantRulesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetAssistantRulesRequestPayload,
      TGetAssistantRulesResponsePayload
    >('/get_assistant_rules', payload, options),

  /** Returns the assistant settings */
  getAssistantSettings: (
    payload: TGetAssistantSettingsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetAssistantSettingsRequestPayload,
      TGetAssistantSettingsResponsePayload
    >('/get_assistant_settings', payload, options),

  /** Sets the assistant's general rules */
  setGeneralRules: (
    payload: TSetGeneralRulesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetGeneralRulesRequestPayload,
      TSetGeneralRulesResponsePayload
    >('/set_general_rules', payload, options),

  /** Updates an assistant rule */
  updateAssistantRule: (
    payload: TUpdateAssistantRuleRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateAssistantRuleRequestPayload,
      TUpdateAssistantRuleResponsePayload
    >('/update_assistant_rule', payload, options),

  /** Updates the assistant settings */
  updateAssistantSettings: (
    payload: TUpdateAssistantSettingsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateAssistantSettingsRequestPayload,
      TUpdateAssistantSettingsResponsePayload
    >('/update_assistant_settings', payload, options),
});
